module.exports = __webpack_public_path__ + "img/4.bc02ed64.svg";